import useInvokeAsync from 'components/App/hooks/useInvokeAsync'
import { getColorToken, getIconId } from 'lib/cartography'
import React, { useCallback } from 'react'

interface SvgPdsIconProps {
  className?: string
  categoryId?: string
}

export function SvgPdsIcon({ className, categoryId }: SvgPdsIconProps): JSX.Element | null {
  const iconData = useInvokeAsync(
    useCallback(async () => {
      const result = await getIconId(categoryId)
      return result
    }, [categoryId])
  )

  const colorTokenData = useInvokeAsync(
    useCallback(async () => {
      const result = await getColorToken(categoryId)
      return result
    }, [categoryId])
  )

  const [name, color] = [iconData.result as string, `var(${colorTokenData.result as string})`]

  return (
    <svg className={className} width="100%" height="100%">
      <use href={`#${name}`} fill={color} />
    </svg>
  )
}
